export const buildUrlSearchProductsPage = (valueSearch?: string) =>
  `/catalogsearch/result/?q=${valueSearch ?? ''}`
